import { Component, forwardRef, Inject, NgZone, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AUTH, KEY_LOCALSTORAGE } from './constant/constant';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
import { DOMAIN_CONSTANT } from './constant/domain-constant';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    title = 'Chính quyền số';
    currentMessage = new BehaviorSubject(null);

    constructor(@Inject(forwardRef(() => TranslateService)) private translateService: TranslateService,
                private afMessaging: AngularFireMessaging,
                private ngZone: NgZone) {
      var language = localStorage.getItem(KEY_LOCALSTORAGE.LANGUAGE);
      if (!language) {
          language = KEY_LOCALSTORAGE.LANGUAGE_DEFAULT;
          localStorage.setItem(KEY_LOCALSTORAGE.LANGUAGE, language);
      }
      // this language will be used as a fallback when a translation isn't found in the current language
      this.translateService.setDefaultLang(language);

      // the lang to use, if the lang isn't available, it will use the current loader to get them
      this.translateService.use(language);
    }


    ngOnInit() {
        this.setEnviroment();
        this.requestPermission();
        this.afMessaging.onTokenRefresh(() => {
            // this.requestPermission();
        });
        window['angularComponentReference'] = { component: this, zone: this.ngZone, loadAngularFunction: (payload) => this.angularFunctionCalled(payload) };
    }

    setEnviroment() {
      let item = DOMAIN_CONSTANT.find(p => p.domain == (window.location.hostname).toString());
      localStorage.setItem('url', item.url);
      localStorage.setItem('maTinh', item.maTinh);
      localStorage.setItem('tenTinh', item.tenTinh);
      localStorage.setItem('domain_san', item.domain_san);
      localStorage.setItem('sumaryWord', item.name_summary);
    }

    requestPermission() {
        var userDetail = localStorage.getItem(AUTH.USER_INFO_KEY);
        if (userDetail) {
            var detail = JSON.parse(userDetail);
            var danhSachNhomQuyen = detail.danhSachNhomQuyen.map(p => p.KY_HIEU);
            danhSachNhomQuyen.push("public");
            // this.afMessaging.requestToken.subscribe((token) => {
            //     danhSachNhomQuyen.forEach(topic => {
            //         fetch('https://iid.googleapis.com/iid/v1/' + token + '/rel/topics/' + topic, {
            //             method: 'POST',
            //             headers: new Headers({
            //                 'Authorization': 'key=AAAATSpfI8A:APA91bGqFwKBfj0EknyXhgscYEiqbjR7BvqgU4_BZ2PuLZ-u2rtKTlFxzgyHphF66-dy2ft-HQkm5jU1vvx3sy6RAOKsAuxgMH6utuyHnEsTldq9H1-t--pNqGtf0ZVDQ0cmC7ZI7l7T'
            //             })
            //         }).then(response => {
            //             if (response.status < 200 || response.status >= 400) {
            //                 throw 'Error subscribing to topic: ' + response.status + ' - ' + response.text();
            //             }
            //         }).catch(error => {
            //             console.error(error);
            //         })
            //     });
            // });
        }
    }

    angularFunctionCalled(payload) {
        console.log("Received background message: ", payload);
    }
}
